import { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import Link from 'next/link'
import { Navigation, Autoplay, Pagination } from 'swiper'
import { useDispatch, useSelector } from 'react-redux'
import { getOffersList } from '../../redux/slices/common'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import { Skeleton, Box, Typography, Grid, Stack, Button } from '@mui/material'
import { ArrowForward } from '@mui/icons-material'

const BannerSlider = ({
  router,
  pageName,
  imageLocal,
  line1,
  highlight,
  line2,
  descrption,
  handleEnquiryClick
}) => {
  const capitalizedPageName = pageName
    ? pageName.charAt(0).toUpperCase() + pageName.slice(1)
    : ''
  const dispatch = useDispatch()
  const [banners, setBanners] = useState([])
  const { bannerList } = useSelector(state => state.common)
  const [isBannerDisabled, setIsBannerDisabled] = useState(false)
  const [loader, setLoader] = useState(false)

  return loader ? (
    <div className='mb-2 mb-md-5 mt-10'>
      <Skeleton variant='rectangular' width='100%' height={180} />
    </div>
  ) : (
    <div className='banner-slider-container-invest mt-60 rsl__Wrapper_invest'>
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 3000 }}
        speed={2000}
        pagination={{ clickable: true }}
        className='banner-slider-invest'
        style={{ width: '100%', height: '100%' }}
        spaceBetween={20}
      >
        {imageLocal?.map((item, index) => (
          <SwiperSlide key={index}>
            <div className='banner-overlay-text'>
              <h2>
                {line1} <span className='highlight'>{highlight}</span> <br />
                {line2}
              </h2>
              <h4>{descrption}</h4>

              {
                handleEnquiryClick &&
                <Button
                  variant='outlined'
                  size='small'
                  endIcon={<ArrowForward />}
                  sx={{
                    // padding: '8px 24px',
                    mt: '2px',
                    fontSize: '16px',
                    fontWeight: 600,
                    borderRadius: '8.87px',
                    borderColor: 'white',
                    color: '#fff',
                    textTransform: 'none',
                    boxShadow: 'none',
                    '&:hover': {
                      borderColor: '#d2d2d2',
                      boxShadow: 'none'
                    }
                  }}
                  onClick={handleEnquiryClick}
                >
                  Invest Now
                </Button>
              }

            </div>
            {/* <Link href={item?.link} key={item._id} target='_blank'> */}
            <div className='image-wrapper' key={item._id}>
              <img
                // src={`${process.env.IMAGE_BASE_URL}/${item.image}`}
                src={`${process.env.IMAGE_BASE_URL}${item.image}`}
                alt={`Banner ${index + 1}`}
                className='banner-image-invest'
              />
              <div className='image-overlay' />
            </div>
            {/* </Link> */}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default BannerSlider
